import Attachment from './Attachment'
import {
  normalizeAttachments,
  Attachment as AttachmentType,
  AttachmentError,
  allowedFilesError
} from './utils'

/* eslint-disable import/no-internal-modules */
import Icon from '@insided/deprecated-preact-components/assets'
import Phrase from '@insided/deprecated-libs/translationsUtils/phrase'

interface AttachmentListProps {
  attachments?: AttachmentType[]
  errors?: AttachmentError[]
  onDelete: (index: number) => void
  onDismissError: () => void
}

const AttachmentList = ({ attachments = [], errors = [], onDelete, onDismissError }: AttachmentListProps) => {
  if (!attachments.length && !errors.length) {
    return null
  }
  attachments = normalizeAttachments(attachments)
  return (
    <div className='content-attachments'>
      {
        Boolean(errors.length) &&
          <p className='content-attachments__error'>
            <span>
              {errors.map(({ filename, errorPhrase }) => {
                return (
                  <span key={filename}>{filename}: <Phrase m='Common' p={errorPhrase} count={allowedFilesError} />
                    <br />
                  </span>
                )
              })}
            </span>
            <Icon width='18' height='18' icon='close' customClass='content-attachments__error-close' onClick={onDismissError} />
          </p>
      }
      {
        Boolean(attachments.length) &&
          <div>
            <p className='content-attachments__counter'>
              <strong>{attachments.length} Attachments</strong>
            </p>
            <ul className='content-attachments-list'>
              {attachments.map(({ filename, url }, index) => {
                return (
                  <Attachment filename={filename} url={url} onDelete={() => onDelete(index)} key={index} />
                  )
              })}
            </ul>
          </div>
    }
    </div>
  )
}

export default AttachmentList
